export class PiperingBossModel {
    _id: string;
    id: number;
    name: string;
    claw: number;
    isDoubleConnected: boolean;


    constructor(_id = null,
        id = null,
        name = '',
        claw = null,
        isDoubleConnected = false,
    ) {
        this._id = _id;
        this.id = id;
        this.name = name;
        this.claw = claw;
        this.isDoubleConnected = isDoubleConnected;
    }
}
